import { useState } from 'react';
import { useAuth } from '../../lib/useAuth';
import { Field, FormNotice } from './MemberForm';
import { fieldErrorsFrom, messageFrom, type FieldErrors } from './memberErrors';

export function MemberPasswordCard() {
  const { changePassword } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [errors, setErrors] = useState<FieldErrors>({});
  const [error, setError] = useState<string | null>(null);
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setErrors({});
    setSaved(false);
    setBusy(true);
    try {
      await changePassword({ currentPassword, newPassword });
      setCurrentPassword('');
      setNewPassword('');
      setSaved(true);
    } catch (err) {
      setErrors(fieldErrorsFrom(err));
      setError(messageFrom(err, 'We could not change your password.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="member-card">
      <h3>Password</h3>
      <p className="po-muted">
        This changes the password for your Secrets Hideaway account everywhere, not just here.
      </p>

      {error ? <FormNotice kind="error">{error}</FormNotice> : null}
      {saved ? <FormNotice kind="info">Your password has been changed.</FormNotice> : null}

      <form onSubmit={submit} noValidate>
        <Field label="Current password" name="currentPassword" errors={errors}>
          <input
            id="currentPassword"
            className="form-input"
            type="password"
            autoComplete="current-password"
            required
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
        </Field>

        <Field label="New password" name="password" errors={errors}>
          <input
            id="password"
            className="form-input"
            type="password"
            autoComplete="new-password"
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </Field>

        <button className="button button-primary" type="submit" disabled={busy}>
          {busy ? 'Changing…' : 'Change password'}
        </button>
      </form>
    </div>
  );
}
